<script>
export default {
    name: "SpecificCashItemsListCreate",

    data() {

        return {
            items: [],
        };
    },

    components: {

        'specific-cash-items-form': () => import('./Form.vue'),
    },

    mounted() {
      this.$root.loading = true;
      Promise.all([ this.fetchItems(), ]).then(() => {
        this.$root.loading = false;
      }).catch(() => {
        this.$root.loading = false;
      });
    },

    methods: {

      fetchItems() {

        return this.$http.get(`MasterData/GetCashItems`).then(response => {
          this.items = response.data;
        }).catch(() => {});
      },
    },
}
</script>
<template>
    <tail-base-layout>
        <template v-slot:content>
            <tail-card>
              <template v-slot:card-header>
                <div class="flex w-full md:flex-row sm:flex-col">
                  <h5 class="flex-1 font-medium">Specific Cash Items</h5>
                </div>
              </template>
              <template v-slot:card-body>
                <specific-cash-items-form ref="cashItemForm" @refreshData="fetchItems"></specific-cash-items-form>
                <table class="table">
                  <thead class="bg-blue-500 text-white text-xs">
                    <tr class="flex w-full">
                      <th class="p-tiny flex-1">Id</th>
                      <th class="p-tiny w-56 break-words">Name</th>
                      <th class="p-tiny flex-1">Status</th>
                      <th class="p-tiny flex-1">Username</th>
                      <th class="p-tiny flex-1">Date</th>
                      <th class="p-tiny flex-1">Action</th>
                    </tr>
                  </thead>
                  <tbody class="bg-gray-100 text-xs flex flex-col items-center overflow-auto" 
                    style="max-height:32rem;">
                    <tr class="w-full flex" v-for="item in items" :key="item.itemId">
                      <td class="p-tiny flex-1">{{ item.itemId }}</td>
                      <td class="p-tiny w-56 break-words">{{ item.itemName }}</td>
                      <td class="p-tiny flex-1">{{ item.status ? `Active` : `Inactive` }}</td>
                      <td class="p-tiny flex-1">{{ item.username }}</td>
                      <td class="p-tiny flex-1">{{ item.sysDate | dateFormat }}</td>
                      <td class="p-tiny flex-1">
                        <button 
                        @click.prevent="$refs.cashItemForm.cashItem = item"
                          class="btn-sm btn-info text-xs rounded">
                          Edit
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </template>
              <template v-slot:card-footer>
                <div class="w-full text-right">
                  <router-link :to="{ name: `master-data.index` }" class="btn-sm btn-danger text-xs rounded"><i class="fa fa-caret-left"></i> Back</router-link>
                </div>
              </template>
            </tail-card>
        </template>
    </tail-base-layout>
</template>
